import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

/**
 * Settings → Lead follow-up: escalation thresholds and the task-reason list.
 * Both are per-dealership and dealer-editable.
 */
export default {
  /* ── SLA / escalation ── */
  // → { firstResponseMinutes, unactionedHours, requireNextEvent, escalateToRole, businessHoursOnly, nurtureExpiryWarnDays, updatedAt }
  getSla:  ()     => api.get('/v1/settings/lead-sla').then(unwrap),
  putSla:  (body) => api.put('/v1/settings/lead-sla', body).then(unwrap),

  /* ── Task reasons (includes inactive; the picker uses /v1/task-reasons which does not) ── */
  listReasons:  ()           => api.get('/v1/settings/task-reasons').then(unwrap),
  createReason: (body)       => api.post('/v1/settings/task-reasons', body).then(unwrap),
  updateReason: (code, body) => api.patch(`/v1/settings/task-reasons/${encodeURIComponent(code)}`, body).then(unwrap),
  deleteReason: (code)       => api.delete(`/v1/settings/task-reasons/${encodeURIComponent(code)}`).then(unwrap),
};
